import { bind } from "@react-rxjs/core"
import { format } from "date-fns"
import { map } from "rxjs"

import { getPrice$ } from "@/services/prices"

export const [useDate, header$] = bind((symbol: string) =>
  getPrice$(symbol).pipe(
    map(
      ({ valueDate }) =>
        `SPT (${format(new Date(valueDate), "dd MMM").toUpperCase()})`,
    ),
  ),
)
